import styled from 'styled-components';
import { font } from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';

export const StyledConceptQuestActivity = styled.div`
  font-family: ${font.family};
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;
